import React, { useRef } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { checkoutApi } from '../lib/api';

export default function PayPalCheckout({ onSuccess, onError }) {
  const orderIdRef = useRef(null);

  return (
    <div data-testid="paypal-buttons-container">
      <PayPalScriptProvider
        options={{
          clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
          currency: 'EUR',
          intent: 'capture',
        }}
      >
        <PayPalButtons
          style={{ layout: 'vertical', color: 'black', shape: 'rect', label: 'paypal', height: 48 }}
          createOrder={async () => {
            const res = await checkoutApi.create({
              origin_url: window.location.origin,
              payment_method: 'paypal',
            });
            orderIdRef.current = res.data.order_id;
            const ppRes = await checkoutApi.paypalCreateOrder(res.data.order_id);
            return ppRes.data.paypal_order_id;
          }}
          onApprove={async (data) => {
            try {
              await checkoutApi.capturePaypal({
                order_id: orderIdRef.current,
                paypal_order_id: data.orderID,
              });
              onSuccess(orderIdRef.current);
            } catch (error) {
              onError(error);
            }
          }}
          onError={(err) => {
            console.error('PayPal error:', err);
            onError(err);
          }}
        />
      </PayPalScriptProvider>
    </div>
  );
}
